<template>
  <div id="payDraw"></div>
</template>
<script>
var chart;
export default {
  data() {
    return {
      myData: {
        xData: [
          "KM01",
          "KM02",
          "KM04",
          "KM05",
          "KM06",
          "KM07",
          "KM08",
          "KM09",
          "KM11",
          "KM12",
          "KM13",
          "KM14",
        ],
        yData: [12, 32, 15, 14, 27, 9, 7],
      },
    };
  },
  methods: {
    reachData(data) {
      this.myData = {
        xData: [],
        yData: [],
      };
      for (let i = 0; i < data.length; i++) {
        this.myData.xData.push(data[i].carNo);
        this.myData.yData.push(data[i].mileage);
      }
      this.draw();
    },
    draw() {
      this.chart = this.echarts.init(document.getElementById("payDraw"));
      this.option = {
        backgroundColor: "",
        grid: {
          x: 50,
          y: 20,
          x2: 40,
          y2: 80, //距离下边的距离
        },
        dataZoom: [
          {
            type: "inside",
            //type: "slider",
            start: 0, //放大起点
            //end: this.list.length<500?100:100/(this.list.length/500) //放大终点
            end: 100, //放大终点
          },
        ],
        xAxis: {
          type: "category",
          data: this.myData.xData,
          axisLabel: { rotate: 45 },
        },
        yAxis: {
          type: "value",
        },
        color: "#05c846",
        series: [
          {
            data: this.myData.yData,
            type: "bar",
            label: {
              show: false,
              position: "top",
            },
          },
        ],
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return val.name + "：" + val.value + "km";
          },
        },
      };
      this.chart.setOption(this.option);
      this.chart.resize();
    },
  },
  //调用
  mounted() {
    //this.drawBar("olinow");
    //this.draw();
  },
  destroyed() {},
};
</script>
<style lang="">
#payDraw {
  width: calc(100% - 20px);
  height: 300px;
  overflow: auto;
  background: #d4dfe9;
  margin: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/licheng/draw.vue